import { render, staticRenderFns } from "./Moves.vue?vue&type=template&id=46f010dc&scoped=true&"
import script from "./Moves.vue?vue&type=script&lang=js&"
export * from "./Moves.vue?vue&type=script&lang=js&"
import style0 from "./Moves.vue?vue&type=style&index=0&id=46f010dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f010dc",
  null
  
)

export default component.exports